import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Icon,
  Input,
  useToast,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { useApiError } from "../../../../common/errors/useApiError";
import { useSaveOrganization } from "../useOrganizationEditor";

interface Props {
  currentValue: string;
}

interface FormValues {
  companyName: string;
}

export const ChangeName = ({ currentValue }: Props) => {
  const toast = useToast();
  const { saveOrganization, isSaving } = useSaveOrganization();
  const { t } = useTranslation();
  const displayer = useApiError();

  const {
    formState: { errors },
    register,
    handleSubmit,
    watch,
  } = useForm<FormValues>({
    defaultValues: {
      companyName: currentValue,
    },
  });

  const value = watch("companyName");

  const onSubmit = async (values: FormValues) => {
    try {
      await saveOrganization({ name: { value: values.companyName } });
      toast({ title: t("Name has been updated!"), status: "success" });
    } catch (e) {
      displayer.trigger(e);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl mt="15px" isInvalid={errors.companyName !== undefined}>
          <FormLabel htmlFor={"companyName"}>{t("Company name")}</FormLabel>
          <Input
            id={"companyName"}
            type="text"
            {...register("companyName", {
              minLength: {
                value: 2,
                message: t("Must be at least 2 characters long"),
              },
            })}
          />
          <FormErrorMessage>{errors.companyName && errors.companyName.message}</FormErrorMessage>
          <FormHelperText>{t("Please provide a company name")}.</FormHelperText>
        </FormControl>
        {currentValue.trim() !== value.trim() && (
          <Button
            mt="10px"
            leftIcon={<Icon as={FaSave} w="15px" h="15px" mt="-2px" />}
            variant={"solid"}
            colorScheme="teal"
            size={"sm"}
            isLoading={isSaving}
            type="submit"
          >
            {t("Save change")}
          </Button>
        )}
      </form>
    </>
  );
};
